// @ts-nocheck


import React from 'react';


import { contractVehiclePlanApi } from './../../lib/api';

import { contractVehiclePlanInfoString } from '../../lib/helpers';

import AutocompleteSelect from './AutocompleteSelect';



export default ({ filter = {}, ...selectProps }) => {
  return (
    <AutocompleteSelect
      fetch={async (params) => {
        return await contractVehiclePlanApi.fetch({
          ...params,
          ...filter
        });
      }}
      refetchParams={{ filter }}
      fetchSingle={contractVehiclePlanApi.get}
      notFoundText="Бюджеты не найдены"
      placeholder="Выберите бюджет"
      renderOption={(vehiclePlan, Option) =>
      <Option
        key={vehiclePlan.id}
        value={vehiclePlan.id}
        vehiclePlan={vehiclePlan}>

          {contractVehiclePlanInfoString(vehiclePlan)}
        </Option>
      }
      {...selectProps} />);


};
